module.exports = __webpack_public_path__ + "0caac0395354804e.jpg";